<template>
  <div class="home-skeleton">
    <div class="item" :style="{ backgroundColor: bg }">
      <shSkeleton bg="#e4e4e4" width="400px" height="400px" animated />
      <div class="item-dot">
        <shSkeleton bg="#e4e4e4" width="68px" height="68px" animated />
        <shSkeleton bg="#e4e4e4" width="68px" height="68px" animated />
        <shSkeleton bg="#e4e4e4" width="68px" height="68px" animated />
        <shSkeleton bg="#e4e4e4" width="68px" height="68px" animated />
        <shSkeleton bg="#e4e4e4" width="68px" height="68px" animated />
      </div>
    </div>
    <div class="item-desc">
      <!-- <div class="item-title"> -->
      <shSkeleton bg="#e4e4e4" width="685px" height="45px" animated />
      <!-- </div> -->
      <shSkeleton bg="#e4e4e4" width="550px" height="35px" animated />

      <shSkeleton bg="#e4e4e4" width="550px" height="70px" animated />
      <shSkeleton bg="#e4e4e4" width="550px" height="70px" animated />
      <shSkeleton bg="#e4e4e4" width="550px" height="70px" animated />
      <shSkeleton bg="#e4e4e4" width="300px" height="70px" animated />
      <!--  <shSkeleton bg="#e4e4e4" width="185px" height="24px" animated /> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeSkeleton",
  props: {
    bg: {
      type: String,
      default: "#fff",
    },
  },
};
</script>

<style scoped lang="less">
.home-skeleton {
  width: 1240px;
  height: 380px;
  display: flex;
  position: absolute;
  //flex-wrap: wrap;
  margin-left: 7px;
  margin-top: 10px;
  //justify-content: space-between;

  .item {
    width: 400px;
    height: 400px;
    margin-left: 8px;
    margin-top: 5px;
    border-radius: 5px;
    .item-dot {
      margin-top: 15px;
      //padding-right: 8px;
      display: flex;
      justify-content: space-between;
    }
    /*  .sh-skeleton {
      width: 65px;
      height: 30px;
    } */
    //margin-bottom: 8px;
    /* .sh-skeleton ~ .sh-skeleton {
      display: block;
      margin: 8px auto 0;
    } */
  }
  .item-desc {
    width: 690px;
    margin-left: 20px;
    margin-top: 5px;
    .sh-skeleton {
      margin-top: 5px;
      &:last-child {
        margin-left: 500px;
      }
    }
  }
}
</style>
